import { type FC } from 'react'
import { Typography } from 'shared/ui'
import { isMac } from 'shared/lib/deviceDetector'
import styles from './styles.module.scss'

const modifierLabels: Record<string, { mac: string; other: string }> = {
  ctrl: { mac: '⌘', other: 'Ctrl' },
  shift: { mac: '⇧', other: 'Shift' },
  alt: { mac: '⌥', other: 'Alt' },
}

const resolveKeyLabel = (key: string): string => {
  const modifier = modifierLabels[key]

  if (modifier) {
    return isMac ? modifier.mac : modifier.other
  }

  return key
}

type ITooltipShortcutProps = {
  label: string
  keys: string[]
}

export const TooltipShortcut: FC<ITooltipShortcutProps> = ({ label, keys }) => (
  <div className={styles.wrap}>
    <Typography variant={'body-md-regular'} ariaLabel={'ShortcutLabel'}>
      {label}
    </Typography>
    <div className={styles.keys}>
      {keys.map((key) => (
        <Typography
          key={key}
          className={styles.key}
          variant={'body-sm-medium'}
          ariaLabel={'ShortcutKey'}
        >
          {resolveKeyLabel(key)}
        </Typography>
      ))}
    </div>
  </div>
)
